import { todayToUnix } from 'webui/utils/unixtime';
import { calculateDistanceBetweenCoordinatesLastGPS } from 'shared/map/lib/utils';
/**
 * @function
 * 1.Если прошло больше 5 минут, то стоим
 * 2.Если скорость больше 5 км\ч, то едем
 * @param last_point: LastGPS
 * @param prev_point: LastGPS
 * @param current_time: Unixtime
 * @return едем или стоим
 */
export function rideOrParking(last_point, prev_point, current_time = todayToUnix()) {
    let { speed, time } = last_point;
    //Если это очень старая точка(больше 5 минут), то ТОЧНО стоим
    if (current_time - time > 60 * 5) {
        return '-parking';
    }
    //Если скорость не знаем, то надо вычислить
    if (speed == null) {
        //скорость м\с
        const speed_m_s = calculateDistanceBetweenCoordinatesLastGPS(last_point, prev_point) /
            (time - prev_point.time);
        speed = speed_m_s * 3.6;
    }
    //Если скорость большая
    if (speed >= 5) {
        return '-ride';
    }
    return '-parking';
}
